module.exports = __webpack_public_path__ + "img/depth.8bfb19bf.jpg";